import { render } from "./Affirm.vue?vue&type=template&id=70603cc6"
import script from "./Affirm.vue?vue&type=script&lang=js"
export * from "./Affirm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\stefan.keyser\\source\\wearetriple\\repos\\Giant.B2C\\Giant.Website\\vue-apps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__